
export const isWechat = /MicroMessenger/i.test(navigator.userAgent)
export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
export const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
export const isIp = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/i.test(location.hostname)

export function setCookie (cname: string, cvalue: string, exdays = 1) {
  const date = new Date()
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000)
  document.cookie = `${cname}=${cvalue};expires=${date.toUTCString()}`
}

export function getCookie (cname: string): string | undefined {
  const name = cname + '='
  const segments = document.cookie.split(';')
  for (const segment of segments) {
    const ca = segment.trim()
    if (ca.indexOf(name) === 0) {
      return ca.substring(name.length, ca.length)
    }
  }
  return undefined
}

export function getUrlParam (name: string): string | undefined {
  name = name.toLowerCase()
  const segments = location.search.replace('?', '').split('&')
  for (const segment of segments) {
    const index = segment.indexOf('=')
    if (index < 0) {
      continue
    }
    const key = segment.substring(0, index)
    if (key.toLowerCase() === name) {
      return segment.substring(index + 1)
    }
  }
  return undefined
}
